import { render } from "./MenuCategoryEdit.vue?vue&type=template&id=11791aca"
import script from "./MenuCategoryEdit.vue?vue&type=script&lang=js"
export * from "./MenuCategoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__